module.exports = __webpack_public_path__ + "img/a3-s66.7f06a150.jpg";